<template>
  <div>
    <Header :ifblueno="ifblueno"></Header>
    <breadcrumb :secondhref="secondhref" :secondtest="secondtest"></breadcrumb>
    <div class="content-body body-box">
      <div class="main-item">
        <div class="body-left">
          <div class="test-box">
            <div class="test-head">
              <span v-for="(c,index) in cate" ref="Constitution" :key="index" :id="c.id" :class="{'test-title-on':c.id===ifSelection,'test-title-off':c.id!==ifSelection}" @click="viceNavigation($event)">{{c.title}}</span>
            </div>
            <ul class="test-ul" style="list-style: none">
              <item-notice v-for="(n,index) in notices" :key="index" :title="n.title" :create_time="n.create_time" :articleId="n.id" :tabName="topName"></item-notice>
            </ul>
            <div class="test-btns">
              <input class="btn" type="button" value="<<" @click="previousPage"/>
              <input class="btn" type="button" v-for="(value, index) in pageSum" :key="index" :value="value" @click="witchPage">
              <input class="btn" type="button" value="..." v-show="pageSum === 11">
              <input class="btn" type="button" value=">>" @click="nextPage"/>
            </div>
          </div>
        </div>
        <!--<div class="body-right">
          <contact></contact>
        </div>-->
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from '@/components/footer/footer.vue'
import Header from '@/components/header/header.vue'
import breadcrumb from '@/components/breadcrumb/breadcrumb.vue'
import contact from '@/components/contact/contact.vue'
import itemNotice from '@/components/item/itemNotice.vue'
import HttpServer from '@/utils' // 接口请求
import '../../node_modules/bootstrap/dist/js/bootstrap.js'

export default {
  name: 'notice',
  data () {
    return {
      // 所在页面的名称
      topName: 'message',
      // 顶部导航栏
      ifblueno: {
        color: '#0051bd'
      },
      // 面包屑导航栏
      secondhref: '/notice',
      secondtest: '站内通知',
      // 副导航栏信息
      cate: [],
      // 总页数
      pageSum: 1,
      // 当前所在副导航栏
      ifSelection: 0,
      // 当前所在页面
      page: 1,
      // 通知列表
      notices: {}
    }
  },
  mounted () {
    // 调用本页接口
    HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName).then(res => {
      this.notices = res.message
      this.cate = res.cate
      this.ifSelection = res.cate[0].id
      this.pageSum = Math.ceil(res.total / res.page_limit)
      if (this.pageSum > 10) {
        this.pageSum = 11
      }
    })
  },
  methods: {
    // 副导航栏
    viceNavigation (event) {
      this.ifSelection = +event.target.id
      HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&cateid=' + this.ifSelection).then(res => {
        this.notices = res.message
        this.cate = res.cate
        this.page = 1
      })
    },
    // 上一页
    previousPage: function () {
      if (this.page !== 1) {
        this.page--
      }
      HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&cateid=' + this.ifSelection + '&page=' + this.page).then(res => {
        this.notices = res.message
      })
    },
    // 下一页
    nextPage: function () {
      if (this.page <= this.pageSum - 1) {
        this.page++
      }
      HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&cateid=' + this.ifSelection + '&page=' + this.page).then(res => {
        this.notices = res.message
      })
    },
    // 具体的某页
    witchPage (event) {
      this.page = +event.target.value
      HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&cateid=' + this.ifSelection + '&page=' + this.page).then(res => {
        this.notices = res.message
      })
    }
  },
  components: {
    Footer: Footer,
    Header: Header,
    breadcrumb: breadcrumb,
    contact: contact,
    itemNotice: itemNotice
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @import '../../node_modules/bootstrap/dist/css/bootstrap.css';
  @import 'joinprocess/main.css';
  .body-box{
    margin-top: 10px;
    background-color: #f5f5f5;
    overflow: hidden;
    min-height: 600px;
  }
  .body-left{
    width: 950px;
    float: left;
  }
  .body-right{
    width: 200px;
    float: right;
  }
  .test-box{
    padding: 12px;
    background-color: #ffffff;
    font-size: 12px;
    text-align: left;
  }
  .test-head{
    height:30px;
    margin-bottom: 15px;
    border-bottom: 1px solid #d7d7d7;
  }
  .test-title{
    font-size: 14px
  }
  // 翻页部分的样式
  .test-ul{
    list-style: none;
    margin-left: 0px
  }
  .test-btns{
    width: 100%;
    height: 30px;
    text-align: center
  }
  .test-btns input{
    padding: 0px 8px;
    margin: 0px 5px;
  }
  .test-btns{
    width: 100%;
    height: 30px;
    text-align: center
  }
  .test-btns input{
    padding: 0px 8px;
    margin: 0px 5px;
  }
  .test-title-on{
    font-size: 14px;
    margin: 0px 5px;
    cursor:pointer;
    color: #0051bd;
  }
  .test-title-off{
    font-size: 14px;
    margin: 0px 5px;
    cursor:pointer;
    color: #000000;
  }
</style>



// WEBPACK FOOTER //
// src/components/notice.vue